export const scrollToSelectedLocation = (element, scrollContainer) => {
    const elementRect = element.getBoundingClientRect();
    const scrollContainerRect = scrollContainer.getBoundingClientRect();
    const position = {
        top: elementRect.top - scrollContainerRect.top + scrollContainer.scrollTop
    };

    scrollContainer.scrollTo({
      top:position.top,
    })

    return position;
};
